var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"jetstar-holidays-ui-9888-production"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["jetstar-holidays-ui@qantashotels"]={id:"jetstar-holidays-ui-9888-production"};
      